{
  "analysis": {
    "analysis_help_title": "How to use the tools",
    "analysis_help_description": "Use the drawing tools to draw a line or area on the map. With a object selected, expand the sections below to show different types of analysis."
  },
  "sidebarToolbar": {
    "delete_layer": "Delete layer",
    "remove_layer": "Remove layer"
  },
  "sidebarLayers": {
    "emptyLayer": "'{{ layerName }}' has no objects yet",
    "emptyGroup": "'{{ groupName }}' has no layers or groups"
  },
  "attributes": {
    "namingOrder": "Naming order",
    "customerIdentifier": "Customer identifier name",
    "list_items": {
      "add_another_placeholder": "Add another list option",
      "add_first_placeholder": "Add a list option"
    },
    "dataDriven": {
      "canDo": "Attribute-driven styling",
      "noDatafields": "Add attributes to use attribute-driven styling",
      "label": "Set using attributes",
      "tour": {
        "stage_one": {
          "title": "Attribute Driven Styling",
          "content": "You need to add a list attribute before you can style your layer by attribute values"
        }
      }
    },
    "predefined_subtitle": "Choose from a set of ready made attributes",
    "custom_subtitle": "Create your own attribute such as a custom list or text input box",
    "attribute_type": "Attribute type",
    "create_new_attribute": "Create a new attribute by choosing a type from the list below and edit it to your requirements",
    "edit_attribute": "Edit this attribute by choosing a type from the list below and edit it to your requirements",
    "edit_attribute_no_type": "Edit this attribute by using the fields below and edit it to your requirements",
    "create_attribute_title": "Create attribute",
    "edit_attribute_title": "Edit attribute",
    "add_attribute_subtitle": "Add a new attribute by either choosing a predefined one or creating a new one from scratch",
    "predefined_info_title": "Predefined attributes",
    "predefined_info_text": "Project administrators can manage these in Project Settings",
    "predefined_info_link": "Click here to go to 'Project Settings'",
    "create_predefined_title": "Create predefined attribute"
  },
  "styles": {
    "fill": "Fill"
  },
  "layer_tour": {
    "tip_1_welcome": {
      "title": "Customise your layer",
      "content": "You can change how your layer looks, and what information (attributes) you want to store when you add objects to the plan."
    },
    "tip_2_name": {
      "title": "Layer name",
      "content": "Change the name of your layer to help describe what you are adding to the plan"
    },
    "tip_3_attributes": {
      "title": "Attributes",
      "content": "Add attributes (optional) to store information about objects on the plan. For example, you can capture types/categories, costs, quantities, dates or anything else you need."
    },
    "tip_4_styles": {
      "title": "Styles",
      "content": "Change how objects in this layer will look on the plan - such as colours and sizes."
    },
    "tip_5_attribute_styles": {
      "title": "Attribute based styling",
      "content": "Use attributes to determine how objects look. For example, different 'types/categories' could have different colours."
    },
    "tip_6_save": {
      "title": "Save",
      "content": "When you're done, press save to add the layer to the plan. You can always change these settings later, such as adding more attributes or adjusting the style."
    }
  },
  "formula_summary": {
    "remove_formula": "Remove formula"
  },
  "layer_information": {
    "title": "Layer information",
    "owner_map_location": "Owner plan location",
    "open_in_folder": "Open in folder",
    "created_by": "Created By",
    "created_on": "Created On",
    "last_modified": "Last Modified",
    "permissions": "Permissions",
    "view_collaborators": "View and edit collaborators",
    "visualiser_overflow": "... {{ nodeCount }} more folders",
    "edit_style": "Layer settings"
  },
  "edit_layer": {
    "add_to_map": "Add to plan",
    "customise": "Customise template",
    "text_position": "Text position",
    "text_offset": "Text offset"
  },
  "style_errors": {
    "invalid_incrementor_value": "Invalid value. Please enter a value between {{ minValue }} and {{ maxValue }}"
  },
  "style": {
    "error": "Something went wrong, the layer changes were not saved"
  },
  "toolbarButtonTooltips": {
    "confirm_action": "Complete drawing"
  }
}